<template>
    <div id="nav" class="container">
        <div class="navLinks">
      <router-link to="/nation" :class="{ active : currentRoute === 'nation'}" :active="true">Nation</router-link>
      <router-link to="/state" :class="{ active : currentRoute === 'state'}" >State</router-link>
      <router-link to="/county" :class="{ active : currentRoute === 'county'}">County</router-link>
      <router-link to="/personnel" :class="{ active : currentRoute === 'personnel'}">Personnel</router-link>
      <router-link to="/methodology" :class="{ active : currentRoute === 'methodology'}">Methodology</router-link>
      
      
      </div>
      <div class="shareNav">
          <b-icon-share-fill @click="shareViaWebShare" class="shareIcons" />
          <a :href="emailHref"><b-icon-envelope-fill class="shareIcons" /></a>
          <b-icon-printer-fill class="shareIcons" @click="printButton" />

          <FileDownload />
          </div>
          <v-snackbar
        v-model="shareBar"
        :multi-line="true"
                  centered
      >
        <h4>Share</h4>
        <twitter-button
    :shareUrl="queryURL"
    :url="queryURL"
    shareDescription="IEM COVID-19 Vaccination Modeling"
    btnText
  />
<facebook-button
    :shareUrl="queryURL"
    :url="queryURL"
    shareDescription="IEM COVID-19 Vaccination Modeling"
    btnText
  />
  <LinkedInButton
    :shareUrl="queryURL"
    :url="queryURL"
    shareDescription="IEM COVID-19 Vaccination Modeling"
    btnText
  />
        <template v-slot:action="{ attrs }">
          <v-btn
            color="red"
            text
            v-bind="attrs"
            @click="shareBar = false"
            dark
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
</template>
<script>
import { BIconShareFill, BIconEnvelopeFill, BIconPrinterFill, BIconDownload } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
import LinkedInButton from "vue-share-buttons/src/components/LinkedInButton";
import JsonExcel from "vue-json-excel";
import FileDownload from './FileDownload';

import { mapState } from 'vuex';


export default {
  components: {
    BIconShareFill,
    BIconEnvelopeFill,
    BIconPrinterFill,
    TwitterButton,
    FacebookButton,
    LinkedInButton,
    FileDownload
  },
  computed: {
        ...mapState(['currentRoute','selectedStateAbbrev','stateNavRoute','selectedState','emailHref','queryURL','nationCasesTable'])
    },
  data() {
    
    return {
      route: this.$router.currentRoute,
      stateRoute: this.$store.state.stateNavRoute,
      shareBar: false
    }
  },
  methods: {
  shareViaWebShare() {
    if (navigator.share) {
  navigator.share({
    title: 'IEM Vaccination Modeling',
    url: this.queryURL
  })
}
  else {
    this.shareBar = true;
  }
  },
  printButton() {
    window.print();
  }
},
  // watch: {
  //   currentRoute: function() {
      
  //   this.emailHref = "mailto:?Subject=IEM Vaccination Modeling&body=" + url;
  //   }
  // }
}
</script>